import React, { Component, PropTypes } from "react";
import AppPage from "components/AppPage";
import FullScreenDialog from "components/FullScreenDialog";
import CoursioLogo from "components/CoursioLogo";

const styles = {
  root: {
    margin: `2em 3em`,
    textAlign: "center",
  },
  warning: {
    fontSize: 32,
    lineHeight: "normal",
    marginTop: "1em",
  },
};

class NotFound extends Component {
  static displayName = "NotFound";

  static contextTypes = {
    getIntlMessage: PropTypes.func,
  };

  render() {
    return (
      <AppPage style={{ background: "#00c9cc" }}>
        <FullScreenDialog open toolbar={false} overlay={false} padded>
          <div style={styles.root}>
            <CoursioLogo initialFill="#00c9cc" size={100} width="48px" />
            <div style={styles.warning}>
              {this.context.getIntlMessage("notFound")}
            </div>
          </div>
        </FullScreenDialog>
      </AppPage>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/js/components/Route/NotFound.js